import { useMutation } from "@tanstack/react-query";
import { chargeHoursJira } from "../api/timeEntryApi";

// Carga horas mediante issues de Jira (POST time-entry/charge-hours/jira).
// El componente maneja onSuccess / onError para Swal y recarga de datos.
export const useChargeHoursJira = () =>
  useMutation({
    mutationFn: chargeHoursJira,
  });
